import React, { useContext, useState } from 'react'
import { Link } from 'gatsby'
import PointsCircle from 'components/PointsCircle'
import { userContext } from 'global/context/sub-contexts/userContext'
import { modalContext } from 'global/context/sub-contexts/modalContext'
import { enterSweepstake } from 'services/sweepstakes'
import { getSweepsEntryCount } from 'services/user'
import ServerError from 'steps/shared/ServerError'

import './RewardsModal.scss'
import { useEffect } from 'react'

const RewardsModal = ({ closeModal }) => {
  const [numTickets, updateNumTickets] = useState(1)
  const [serverError, setServerError] = useState(false)
  const [purchased, setPurchased] = useState(false)
  const [sweepsEntryCount, setSweepsEntryCount] = useState()
  const [limitReached, setLimitReached] = useState(false)
  const [isWaiting, setIsWaiting] = useState(false)

  const user_context = useContext(userContext)
  const modal_context = useContext(modalContext)
  const { modalContent } = modal_context || {}
  const { askToLogin, setPoints } = user_context

  const handleSweepstakePurchase = async () => {
    setIsWaiting(true)
    try {
      const entryResponse = await enterSweepstake(
        modalContent.sweepId,
        numTickets,
      )
      setPoints(entryResponse.detail.points)
      setIsWaiting(false)
      setPurchased(true)
    } catch (e) {
      console.log(e)
      setIsWaiting(false)
      if (e.detail.status === '401') {
        user_context.unauthorized()
        askToLogin()
      } else {
        setServerError(e.detail.message)
      }
    }
  }

  const handleUpdateNumTickets = newTicketNumber => {
    updateNumTickets(newTicketNumber)
    if (newTicketNumber + sweepsEntryCount > 50) {
      setLimitReached(true)
    } else {
      setLimitReached(false)
    }
  }

  useEffect(async () => {
    try {
      const entryCount = await getSweepsEntryCount(modalContent.sweepId)
      setSweepsEntryCount(entryCount.detail)
      entryCount.detail >= 50 && setLimitReached(true)

      console.log(modalContent)
    } catch (e) {
      if (e.message === '401') {
        user_context.unauthorized()
        askToLogin()
      } else {
        setServerError(true)
      }
    }
  }, [])

  return (
    <>
      {user_context && modal_context && (
        <>
          <div className={`modal-rewards waiting-${isWaiting}`}>
            <div className="modal-header">
              <span
                className={`modal-header-expiry${
                  purchased ? ' purchased' : ''
                }`}
              >
                Sweepstakes Ends: {modalContent.expiryDate} at{' '}
                {modalContent.expiryTime}
              </span>
            </div>
            <div className="content-body">
              <h4>{modalContent.title}</h4>
              <p>{modalContent.description}</p>
              {!purchased && (
                <div className="data-row">
                  <div className="tickets-sold">
                    Tickets Sold
                    <PointsCircle value={modalContent.numberOfEntries} />
                  </div>
                  <div className="your-tickets">
                    Your Tickets
                    <div className="points-circle">
                      <div className="flex-container">
                        <span className="value">{numTickets}</span>
                      </div>
                    </div>
                  </div>
                  <div className="total-price">
                    Total Price
                    <PointsCircle
                      value={modalContent.costToEnter * numTickets}
                      points
                    />
                  </div>
                </div>
              )}
              {purchased && (
                <span className="purchased">
                  Congratulations! You have successfully purchased {numTickets}{' '}
                  ticket(s).
                </span>
              )}
            </div>
          </div>
          <div className={`modal-action action-container waiting-${isWaiting}`}>
            {!purchased && (
              <div className="modal-action ticket-buttons">
                <button
                  className="modal-action minus"
                  onClick={handleUpdateNumTickets.bind(this, numTickets - 1)}
                  disabled={numTickets === 0 ? true : false}
                  aria-label="Minus"
                >
                  -
                </button>
                <button
                  className="modal-action add"
                  onClick={handleUpdateNumTickets.bind(this, numTickets + 1)}
                  disabled={numTickets >= 16}
                  aria-label="Add"
                >
                  +
                </button>
              </div>
            )}
            {!purchased &&
              modalContent.costToEnter * numTickets > user_context.points && (
                <span className="modal-action insufficient-msg">
                  You don't have enough points to make this purchase.
                </span>
              )}
            {!purchased && limitReached && (
              <span className="modal-action insufficient-msg">
                You have exceeded the maximum amount of tickets you can buy for
                this sweepstakes.
              </span>
            )}
            <div className="modal-action confirm">
              {!purchased && (
                <input
                  className="modal-action"
                  type="submit"
                  value="Confirm"
                  onClick={handleSweepstakePurchase}
                  disabled={
                    numTickets === 0 ||
                    modalContent.costToEnter * numTickets >
                      user_context.points ||
                    limitReached
                      ? true
                      : false
                  }
                />
              )}
              {purchased && (
                <input
                  className="modal-action"
                  type="submit"
                  value="Close"
                  onClick={closeModal}
                />
              )}
              {serverError && <ServerError customMessage={serverError} />}
            </div>
            <p className="modal-action terms">
              NO PURCHASE NECESSARY TO ENTER OR WIN. Sweepstakes is open to
              legal residents of the 50 United States or the District of
              Columbia who have attained the age of majority in their state of
              residence as of the date of entry into the sweepstakes or contest.
              Official Rules which govern this Sweepstakes are available at{' '}
              <a href="/info/official-rules" target="_blank">
                Promotion General Terms & Conditions
              </a>
              , and the{' '}
              <a
                href={`/info/sweeps-guidelines/${modalContent.sweepId}`}
                target="_blank"
              >
                Additional Terms & Conditions
              </a>
              . Entries must be received between {modalContent.startDate} at
              12:01 AM and {modalContent.expiryDate} at 12:00 AM. 50 entries per
              person. Odds of winning dependent on the number of eligible
              entries received. Void where prohibited by law. Sponsor:
              Dailybreak, CP LLC.
            </p>
          </div>
        </>
      )}
    </>
  )
}

export default RewardsModal
